import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CronosActionPage } from './cronos-action';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    CronosActionPage
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(CronosActionPage),
  ],
})
export class CronosActionPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cronos-action/cronos-action.module.ts